import {FormBuilderComponentTypes} from './ComponentList';

/**
 * A school that turns on Hide Boarder Groups has no boarders. Its boarder statuses are the Boarder
 * groups, so with them hidden the Boarder Status question has nothing to offer.
 */
export const boarderStatusHidden = (school) => Boolean(school?.hideBoarderGroups);

export const isBoarderStatusQuestion = (field) => field?.type === FormBuilderComponentTypes.BoarderStatusChoice;

/** Takes the Boarder Status question out of a template for a school that hides Boarder groups. */
export const withoutHiddenBoarderStatus = (schema, school) => (
    boarderStatusHidden(school) ? (schema ?? []).filter(field => !isBoarderStatusQuestion(field)) : (schema ?? [])
);
